// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { mapActions } from 'vuex'
import VModal from 'vue-js-modal'
Vue.use(VModal)
import moment from 'moment';
Vue.prototype.$moment = moment;
import { VTooltip } from 'v-tooltip'
Vue.use(VTooltip)
Vue.directive('tooltip', VTooltip)
import VueModal from "vue2-modal";
Vue.use(VueModal);
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
import VueMask from 'v-mask'
Vue.use(VueMask)
import ToggleButton from 'vue-js-toggle-button' 
Vue.use(ToggleButton)
//import Scrollspy from 'vue2-scrollspy';
import Scrollspy, { Easing } from 'vue2-scrollspy';
Vue.use(Scrollspy, {
  easing: Easing.Cubic.In
})
import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, {hideModules: { "image": true, "code":true },});
const VueScrollTo = require('vue-scrollto')
// Vue.use(VueScrollTo)

Vue.use(VueScrollTo, {
  container: "body",
  duration: 2000,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});
import Autocomplete from './components/autocomplete.vue'
const autocomplete = Vue.component('autocomplete', Autocomplete);
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, faInfo, faPlus, faWindowClose, faCheck, faClock,  faComment, faBan, faMoneyCheckAlt, faEdit, faHandHoldingUsd, faLongArrowAltUp, faLongArrowAltDown, faSync } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUserSecret, faInfo, faPlus, faWindowClose, faCheck, faClock, faComment, faBan, faMoneyCheckAlt, faEdit, faHandHoldingUsd, faLongArrowAltUp, faLongArrowAltDown, faSync);
Vue.component('font-awesome-icon', FontAwesomeIcon)
require( "./assets/css/fonts/icomoon.css");
require( "./assets/css/fonts/flag-icon-css/css/flag-icon.min.css");
require( "./assets/css/login-register.css");
require( "./assets/css/notification.css");
require( "./assets/css/bootstrap.css");
require( "./assets/css/bootstrap-extended.css");
require( "./assets/css/app.css");
require( "./assets/css/colors.css");
require( "./assets/css/vertical-menu.css");
require( "./assets/css/vertical-overlay-menu.css");
require( "./assets/css/palette-gradient.css");
require( "./assets/css/input-group.css");
require( "./assets/css/skins/flat/green.css");
import "vue-wysiwyg/dist/vueWysiwyg.css";
import 'vue-good-table/dist/vue-good-table.css'
import VueGoodTablePlugin from 'vue-good-table';
Vue.use(VueGoodTablePlugin);

import LoadScript from "vue-plugin-load-script";

var firebaseConfig = {
  apiKey: "AIzaSyCeQnOJxSlf_Hh4pf2bEP2UmC1c7-Ijc7c",
  authDomain: "me-tender.firebaseapp.com",
  projectId: "me-tender",
  storageBucket: "me-tender.appspot.com",
  messagingSenderId: "374191696711",
  appId: "1:374191696711:web:79783b548d44f474173a62"
};

Vue.use(LoadScript);
// Vue.loadScript("https://www.gstatic.com/firebasejs/8.6.3/firebase-app.js")
// Vue.loadScript("https://www.gstatic.com/firebasejs/8.6.3/firebase-messaging.js")
// Vue.loadScript("/firebase-messaging-sw.js")

Promise.resolve()
  .then(() =>
    Vue.loadScript(
      "https://www.gstatic.com/firebasejs/8.6.3/firebase-app.js"
    )
  )
  .then(() =>
    Vue.loadScript(
      "https://www.gstatic.com/firebasejs/8.6.3/firebase-messaging.js"
    )
  ) 
  
  

  // .then(() => {
  //   window.firebase.initializeApp(firebaseConfig);
  //   const messaging = window.firebase.messaging();


    // // работа с объектом messaging
    // messaging.requestPermission()
    //     .then(function () {
    //         // получаем ID устройства
    //         messaging.getToken()
    //             .then(function (currentToken) {
    //                 // console.log(currentToken);
    //                 if (currentToken) {
    //                     // sendTokenToServer(currentToken);
    //                     console.log("currentToken = " + currentToken);
    //                 } else {
    //                     console.warn('Не удалось получить токен.');
    //                     // setTokenSentToServer(false);
    //                 }
    //             })
    //             .catch(function (err) {
    //                 console.warn('При получении токена произошла ошибка.', err);
    //                 // setTokenSentToServer(false);
    //             });
    // })
    // .catch(function (err) {
    //     console.warn('Не удалось получить разрешение на показ уведомлений.', err);
    // });



    // function sendTokenToServer(params) {
    //   if (params != false) { 
    //     console.log(params);
    //   }
    //   else console.log("params = "+ params);
    // }

  // messaging.onMessage(function(payload) {  
  //   console.log("message taken" + payload) 
  //   navigator.serviceWorker.register("/firebase-messaging-sw.js");
  //   Notification.requestPermission(function(result) {
  //     if (result === "granted") {
  //       navigator.serviceWorker.ready
  //         .then(function(registration) {
  //           console.log("serviceWorker registration") 
  //           const data = { ...payload.notification, ...payload.data };
  //           const notificationTitle = data.title;
  //           const notificationOptions = {
  //             body: data.body,
  //             icon: data.icon,
  //             image: data.image,
  //             click_action: data.click_action,
  //             requireInteraction: true,
  //             data
  //           };
  //           return registration.showNotification(
  //             notificationTitle,
  //             notificationOptions
  //           );
  //         })
  //         .catch(function(error) {
  //           console.log("ServiceWorker registration failed", error);
  //         });
  //     }
  //   });
  // });

  // });


//scripts in one folder
import * as jQuery from "jquery"//"./assets/js/jquery.min.js";
window.$ = window.jQuery=jQuery;

import * as tether from "tether" //import * as tether from  "./assets/js/tether.min.js";
window.Tether = tether;

require ("./assets/js/bootstrap.min.js");
require ("./assets/js/perfect-scrollbar.jquery.min.js");
require ("./assets/js/unison.min.js");
require ("./assets/js/blockUI.min.js");
require ("./assets/js/jquery.matchHeight-min.js");
require ("./assets/js/app-menu.js");
require ("./assets/js/app.js");
require ("./assets/js/icheck.min.js");


import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
  load: {
      key: 'AIzaSyBk3tcGQvTlT3CLfXnhHv7ebh6tXfsMKnA', // AIzaSyDVQDY_Eba5hcOa4n42bJjQmfissLszZnQ 'AIzaSyBzofzW0_tEyVMtSTmAJWDxCjN4L4Vb1WY',//'AIzaSyCFt6CX59qQwRwb-o6wWUbBr4pasY6Ibr4',//'AIzaSyCj4sFn2YfDMUbEpbKzufAsLTxv8Gn_i9U',
      libraries: 'places',
      region: 'Eu',
      language: 'ua',
  },
});
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
Vue.component('GmapCluster', GmapCluster);

import _ from 'lodash';

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import Notifications from 'vue-notification'
Vue.use(Notifications)

Vue.config.productionTip = false

window.axios = require('axios');
window.axios.defaults.baseURL =  'https://http1c.modern-expo.info/BaseCRM/hs/WebModern'
window.axios.defaults.timeout = 60000
window.axios.defaults.headers.common['Cache-Control'] = 'no-cache'
window.axios.defaults.headers.post['Content-Type']    = 'application/json; charset=utf-8'

const names = require('./locales/locales.json');
const i18n = new VueI18n({
  locale: 'ua',
  messages: names
});

Vue.mixin({
  methods:{
    getPermisionForPush(){
      window.firebase.initializeApp(firebaseConfig);
    const messaging = window.firebase.messaging();   
    // работа с объектом messaging
    messaging.requestPermission()
        .then(function () {
            // получаем ID устройства
            messaging.getToken()
                .then(function (currentToken) {
                    // console.log(currentToken);
                    if (currentToken) {
                        // sendTokenToServer(currentToken);
                        console.log("currentToken = " + currentToken);
                    } else {
                        console.warn('Не удалось получить токен.');
                        // setTokenSentToServer(false);
                    }
                })
                .catch(function (err) {
                    console.warn('При получении токена произошла ошибка.', err);
                    // setTokenSentToServer(false);
                });
    })
    .catch(function (err) {
        console.warn('Не удалось получить разрешение на показ уведомлений.', err);
    });

    messaging.onMessage(function(payload) {  
      console.log("message taken" + payload) 
      navigator.serviceWorker.register("/firebase-messaging-sw.js");
      Notification.requestPermission(function(result) {
        if (result === "granted") {
          navigator.serviceWorker.ready
            .then(function(registration) {
              console.log("serviceWorker registration") 
              const data = { ...payload.notification, ...payload.data };
              const notificationTitle = data.title;
              const notificationOptions = {
                body: data.body,
                icon: data.icon,
                image: data.image,
                click_action: data.click_action,
                requireInteraction: true,
                data
              };
              return registration.showNotification(
                notificationTitle,
                notificationOptions
              );
            })
            .catch(function(error) {
              console.log("ServiceWorker registration failed", error);
            });
        }
      });
    });


    },
    showNotification(gr, title, message, classCSS){
      this.$notify({
        group: gr,
        title: title,
        text: message,
        type: classCSS,
        duration: 5000
      })
    },
    isValid(some){
      if((some != null) && (some != 'null') && (some != undefined)&&(some != '') && (typeof(some) != "undefined")){
          return true
      } else {
          return false
      }
    },
    changeLanguage(lang){    
      localStorage.setItem('lang', lang);
      this.$i18n.locale = lang;
      this.$root.$emit('changeLanguage', true);     
     
    },
    makeQuery: function(stringQuery,jsonData, loader = true){
      let data  = jsonData
      data.system = "1"
      if (loader) this.$store.state.isLoading = true;
      return new Promise((resolve, reject) => {
        this.checkAuthorized();

        axios.post(stringQuery, data)
        .then(response => {
          this.$store.state.isLoading = false;
          if (response.status == 200){
            if(typeof response.data == 'string'){
              if(response.data == 'Истина'){
                return resolve(response);
              } else {
              console.log(response.data);
              this.showNotification('custom-error','Error','Contact IT(1C) department');
              }
            } else {
              return resolve(response);
            }
          } else {
            this.showNotification('custom-error','Error','Contact IT department');
            console.log('Something wrong but there is no error, status != 200');
          }
            
        })
        .catch(error => {
          this.$store.state.isLoading = false;
          if ((error.response.status == 500)||(error.response.status == 401)){
            localStorage.removeItem('guidClient');
            localStorage.removeItem('user-token');
            localStorage.removeItem('userGuid');
            this.$router.push({ name: 'login'});
            this.showNotification('custom-error','Error',this.$t('errors.500'));
          } else {
            this.showNotification('custom-error','Error','Contact IT department, server response failed');
            console.log(error);
          }
        });
      });
    },
    makeRequest: function(stringQuery,jsonData, loader = true){
      let data  = jsonData
      data.system = "1"
      if (loader) this.$store.state.isLoading = true;
      return new Promise((resolve, reject) => { 
        axios.post(stringQuery, data)
        .then(response => {
          this.$store.state.isLoading = false;
          if (response.status == 200){
            if(typeof response.data == 'string'){
              if(response.data == 'Истина'){
                return resolve(response);
              } else {
              console.log(response.data);
              this.showNotification('custom-error','Error','Contact IT(1C) department');
              }
            } else {
              return resolve(response);
            }
          } else {
            this.showNotification('custom-error','Error','Contact IT department');
            console.log('Something wrong but there is no error, status != 200');
          }
            
        })
        .catch(error => {
          this.$store.state.isLoading = false;
          if ((error.response.status == 500)||(error.response.status == 401)){                     
            this.showNotification('custom-error','Error',this.$t('errors.tryLate'));
          } else {
            this.showNotification('custom-error','Error','Contact IT department, server response failed');
            console.log(error);
          }
        });
      });
    },
    sendGeodata: function(stringQuery,jsonData){
      this.$store.state.isLoading = true;
      return new Promise((resolve, reject) => { 
        axios.post(stringQuery, jsonData)
        .then(response => {
          this.$store.state.isLoading = false;
          if (response.status == 200){
            if(typeof response.data == 'string'){
              if(response.data == 'Истина'){
                return resolve(response);
              } else {
              console.log(response.data);
              this.showNotification('custom-error','Error','Contact IT(1C) department');
              }
            } else {
              return resolve(response);
            }
          } else {
            this.showNotification('custom-error','Error','Contact IT department');
            console.log('Something wrong but there is no error, status != 200');
          }
            
        })
        .catch(error => {          
          this.$store.state.isLoading = false;
          if( !_.isNil(error.response) ){
            if ((error.response.status == 500)||(error.response.status == 401)){
              this.$router.push({ name: 'login'});
              this.showNotification('custom-error','Error','Contact IT , server response failed');
            }
          } else {
            this.showNotification('custom-error','Error','Contact IT department, server response failed');            
            // console.log("error");
            // return error;
          }
        });
      });
    },
    getGPS: function(){
      let position = { latitude: null, longitude: null, accuracy: null };
      // this.$store.state.isGPS = true;
      // this.$store.state.queueGeo.push(true);  
      let self = this;  
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(function(pos) {
          let crd = pos.coords;
          // console.dir('crd: ' + crd);
          position.latitude = crd.latitude;
          position.longitude = crd.longitude;
          position.accuracy = crd.accuracy;//meters
  
          // self.$store.state.queueGeo.splice(0, 1);
          // if(self.$store.state.queueGeo.length < 1){
          //   self.$store.state.isGPS = false;
          // }
  
          return resolve(position);
        },
        function(err) {
          // self.$store.state.queueGeo.splice(0, 1);
          // if(self.$store.state.queueGeo.length < 1){
          //   self.$store.state.isGPS = false;
          // }
          console.log('Geolocation: ' + err);
          return resolve(position);
        },
        {enableHighAccuracy: true, timeout: 5000, maximumAge: 0});
      });
    },
    anchorTo(nameCont){
      let self = this;
       setTimeout(function(){
           var element = self.$refs[nameCont];
           var top = element.offsetTop;
           window.scrollTo(0, top);
       },200);
       //$('html, body').animate({scrollTop: 0}, 600);//scroll to top
    },
    checkAuthorized: function(){
      return new Promise((resolve, reject) => {
        if((this.$store.state.userToken == null) && (this.$route.name != 'login')&& (this.$route.name != 'fronfPage') && (this.$route.name != 'loginNew') && (this.$route.name != 'register') && (this.$route.name != 'recoveryPaasword') && (this.$route.name != 'traker')){
          console.log(this.$route.name);
          console.log('reloaded, checking LocalStorage');
          this.checkLS();
          this.clearUserInfo();
          this.$router.push({ name: 'login'});
        }
        return resolve();
      });
    },
    checkLS(){
      if(localStorage.getItem('userGuid') != null){ this.$store.state.giudUser = localStorage.getItem('userGuid'); }
      if(localStorage.getItem('user') != null){ this.$store.state.user = localStorage.getItem('user'); }
      if(localStorage.getItem('name') != null){ this.$store.state.userName = localStorage.getItem('name'); }
      if(localStorage.getItem('username') != null){ this.$store.state.login = localStorage.getItem('username'); }
      if(localStorage.getItem('user-token') != null){ this.$store.state.userToken = localStorage.getItem('user-token'); }
      if(localStorage.getItem('email') != null){ this.$store.state.email = localStorage.getItem('email'); }

      if(localStorage.getItem('ip') != null){ this.$store.state.ip = localStorage.getItem('ip'); }
      if(localStorage.getItem('clientName') != null){ this.$store.state.clientName = localStorage.getItem('clientName'); }
      if(localStorage.getItem('clientEdrpo') != null){ this.$store.state.clientEdrpo = localStorage.getItem('clientEdrpo'); }
      if(localStorage.getItem('guidClient') != null){ this.$store.state.guidClient = localStorage.getItem('guidClient'); }

      if(localStorage.getItem('profileImg') != null){ this.$store.commit('setProfilePhoto',localStorage.getItem('profileImg'));}
      
      if(localStorage.getItem('role') != null){        
        let arrRoles = localStorage.getItem('role');
        if (!_.isString(arrRoles)){         
          if(arrRoles.indexOf("logist") > -1){this.$store.commit('setUserRoleLogist', true);}
          if(arrRoles.indexOf("admin") > -1) {this.$store.commit('setUserRoleAdmin', true);}         
          if(arrRoles.indexOf("clientME") > -1){this.$store.commit('setUserRoleUser', true);}
          // if(arrRoles.indexOf("client") > -1){console.log(arrRoles.indexOf("client"))} 
          if(arrRoles.indexOf("client") > -1){this.$store.commit('setUserRoleClient', true);} 
        }
        else {
          switch(arrRoles) {
          case 'admin':
          this.$store.commit('setUserRoleAdmin', true)
          break
          case 'client':
          this.$store.commit('setUserRoleClient', true)
          break
          case 'logist':
          this.$store.commit('setUserRoleLogist', true)
          break
          case 'clientME':
          this.$store.commit('setUserRoleUser', true)
          break
        }
        }
      }
    },
    clearUserInfo(){
      console.log('cleared All storages!!!!!!!')
      localStorage.removeItem('guidClient');
      localStorage.removeItem('user-token');
      localStorage.removeItem('userGuid');
      localStorage.removeItem('role');
      localStorage.removeItem('username');
      localStorage.removeItem('email');
      localStorage.removeItem('user');
      localStorage.removeItem('clientName');
      // this.deleteEqs();

      this.$store.state.profilePhoto = require('./assets/pictures/profile.png');
      this.$store.state.guidUser = null;
      this.$store.state.userToken = null;
      this.$store.state.nameUser = null;
      this.$store.state.name = null;
      this.$store.state.user = null;
      this.$store.state.email = null;
      this.$store.state.guidClient = null;
      this.$store.state.clientName = null;
      this.$store.state.clientEdrpo = null;
      this.$store.state.ip = null;
      this.$store.state.listRole.client = false;
      this.$store.state.listRole.dispatcher = false;
      this.$store.state.listRole.service = false;
      this.$store.state.listRole.serviceOrg = false;
      this.$store.state.listRole.logist = false;
      this.$store.commit('setUserRoleAdmin', false);
      this.$store.state.listRole.user = false;
      this.$store.commit('delUserRole', false);
        
    },
    // async deleteEqs() {
    //   await this.$store.dispatch('deleteEqsFromDb');
    //   this.getEqs();
    // },
    ...mapActions(['getEqs', 'addEqToDb']),
    async addEq (item) {
        await this.addEqToDb({ item })
    },
    
  }
})

Vue.config.devtools = true;

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
  methods:{},
  mounted(){
    if (localStorage.getItem('lang')){
      this.$i18n.locale = localStorage.getItem('lang');
    }
    
  },
  created(){
    this.checkAuthorized()
  }

})




// WEBPACK FOOTER //
// ./src/main.js